import { IBookItem } from "~/utils/interface";

interface ISliderBooks {
  books: IBookItem[];
}

const SliderTropes = ({ books }: ISliderBooks) => {
  return (
    <div className="max-lg:overflow-x-auto w-full">
      <ul
        className="text-white flex flex-wrap gap-x-2 gap-y-4 max-[400px]:w-[252%] max-lg:w-[248%]"
        key="tropes"
      >
        {books.map((trope) => (
          <li
            className="text-white py-2 px-3 text-[16px] leading-[22px] rounded-full bg-[rgba(28,_48,_85,_1)] text-center border border-[rgba(255,_255,_255,_0.1)] w-max"
            key={`single_trope_${trope}`}
          >
            {trope as string}
          </li>
        ))}
      </ul>
    </div>
  );
};

SliderTropes.displayName = "SliderTropes";
export default SliderTropes;
